module.exports = __webpack_public_path__ + "static/basin-overhead-085a5016a289689ea30c7b8fa9d76326.jpg";